export const OPEN_DATA = 'OPEN_DATA';
export const BIS = 'BIS';
export const CITYPAY = 'CITYPAY';
export const NYC_GOV = 'NYC_GOV';
export const COMBINED = 'COMBINED'; //represents combined open data and bis
export const FDNY_SCRAPER = 'FDNY_SCRAPER'; //represents FDNY scraped NOV/VIO data
export const COUNTY_CLERK = 'COUNTY_CLERK'; //represents NY County Clerk / JDLS scraped data (DOT liens)

export const DATA_SOURCES = [
	BIS,
	OPEN_DATA,
	CITYPAY,
	NYC_GOV,
	COMBINED,
	FDNY_SCRAPER,
	COUNTY_CLERK,
];

export function camelCaseDataSource(dataSource) {
	if (dataSource === OPEN_DATA) {
		return 'OpenData';
	} else if (dataSource === BIS) {
		return 'BIS';
	} else if (dataSource === CITYPAY) {
		return 'Citypay';
	} else if (dataSource === NYC_GOV) {
		return 'NYCgov';
	} else if (dataSource === COMBINED) {
		return 'Combined';
	} else if (dataSource === FDNY_SCRAPER) {
		return 'FdnyScraper';
	} else if (dataSource === COUNTY_CLERK) {
		return 'CountyClerk';
	}
	return '';
}

export function prettifyDataSource(dataSource) {
	if (dataSource === OPEN_DATA) {
		// return 'Open Data';
		return 'DOB NOW';
	} else if (dataSource === BIS) {
		return 'BIS';
	} else if (dataSource === CITYPAY) {
		return 'CityPay';
	} else if (dataSource === NYC_GOV) {
		return 'NYC.gov';
	} else if (dataSource === COMBINED) {
		return 'BIS and DOB NOW';
	} else if (dataSource === FDNY_SCRAPER) {
		return 'FDNY';
	} else if (dataSource === COUNTY_CLERK) {
		return 'County Clerk';
	}
	return '';
}

export function getDataSourceApiUrlPath(dataSource) {
	if (dataSource === OPEN_DATA) {
		return 'open-data';
	} else if (dataSource === BIS) {
		return 'bis';
	} else if (dataSource === CITYPAY) {
		return ''; //special case: citypay data source not in api url path
	} else if (dataSource === NYC_GOV) {
		return ''; //special case: nyc.gov data source not in api url path
	} else if (dataSource === COMBINED) {
		return ''; //special case: combined datasets don't have data source in api url path
	} else if (dataSource === FDNY_SCRAPER) {
		return ''; //special case: fdny scraper uses custom endpoints
	} else if (dataSource === COUNTY_CLERK) {
		return ''; //special case: county clerk uses custom endpoints (/dot-liens)
	}
	return '';
}

export function getReducerName(configObj, dataSource) {
	return`${configObj.dataSet}${camelCaseDataSource(dataSource)}`;
}

export function getAppRoute(dataSet, dataSource) {
	return`${dataSet}${camelCaseDataSource(dataSource)}`;
}
